import * as Paths from "../../service/config";
import AspAxios from "../../service/AspAxios";
import {searchUserResellerListPage} from "../../service/config";

function clean(obj) {
  let _obj = {};
  for (const propName in obj) {
    if (obj[propName] !== "") {
      _obj[propName] = obj[propName];
    }
  }
  return _obj;
}

export function upsertUser(request) {
  return new Promise((resolve, reject) => {
    AspAxios.post(Paths.upsertUser, clean(request))
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getAllRoles() {
  return new Promise((resolve, reject) => {
    AspAxios.get(Paths.allRoles)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getRolesByUsage(_usage) {
  return new Promise((resolve, reject) => {
    AspAxios.get(Paths.allRolesByUsage + _usage)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function searchUser(_search, _page, _size) {
  return new Promise((resolve, reject) => {
    AspAxios.post(
      Paths.searchUser + "?page=" + _page + "&size=" + _size,
      clean(_search)
    )
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function searchUserOwn(_search, _page, _size) {
  return new Promise((resolve, reject) => {
    AspAxios.post(
      Paths.searchUserOwn + "?page=" + _page + "&size=" + _size,
      clean(_search)
    )
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function searchResellerUserList(_search,_page,_size) {
  return new Promise((resolve, reject) => {
    AspAxios.post(
      Paths.searchUserResellerListPage + "?page=" + _page + "&size=" + _size,
      clean(_search)
    )
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function activeUser(request) {
  return new Promise((resolve, reject) => {
    AspAxios.post(Paths.activeUser, clean(request))
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function deleteUser(request) {
  return new Promise((resolve, reject) => {
    AspAxios.post(Paths.deleteUser, clean(request))
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
